const generateUniqueID=()=>`v3-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`;export{generateUniqueID};